import { render } from "./Title.vue?vue&type=template&id=5bb3b61a&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=5bb3b61a&scoped=true&lang=scss"
import "./Title.vue?vue&type=style&index=1&id=5bb3b61a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb3b61a"]])

export default __exports__